// extracted by mini-css-extract-plugin
export var btn = "K_mY q_rv q_q9 d_bz d_bP d_bD d_dw";
export var full = "K_vz d_w d_H";
export var hoverStyle = "K_m1";
export var zoom = "K_m2";